import React, { Fragment, useEffect, useReducer, useRef, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { expensePolicyRuleInitialsForAdd, expensePolicyRuleInitialsForUpdate } from './interfaces/expensePolicyRuleClass';
import { addAccountExpensePolicyRuleAsync, updateAccountExpensePolicyRulesAsync, resetSelectedRecordObjectInState } from './expensePolicyRuleSlice';
import Select, { StylesConfig } from 'react-select';
import fetchAPI from '../../../common/fetchAPI';
import { useLocation } from 'react-router-dom';
import * as yup from 'yup';
import { Formik } from 'formik';
import { useTranslation } from "react-i18next";
import { ShowToast } from '../../../common/Toastr';
import CanvasLoader from '../../../common/CanvasLoader';
import { determineCommaSeprater, dropDownSelectionStyles, formatNumberCustomoriginalapiv2, getValueFromResource, parseLocalizedNumber } from '../../../common/timeLiveFunction';


const ExpensePolicyRuleForm = (props: any) => {
    const { modelRef } = props;
     const formikRef = useRef<any>(null);
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(expensePolicyRuleInitialsForAdd)
    const { selectedRecord, isLoading } = useAppSelector((state) => state.expensePolicyRule);
     const { cultureInfoName, decimalFormat, decimalPlaces } = useAppSelector((state) => state.globalState);
    const location = useLocation();
    const { MasterExpensePolicyId } = useAppSelector((state) => state.expensePolicy);
    const { obj } = location.state || {};   
    const storedObjectData = localStorage.getItem('objExpensePolicyItem');
    const objectData = storedObjectData ? JSON.parse(storedObjectData) : null;
     let AccountExpensePolicyId = '00000000-0000-0000-0000-000000000000';
     if (MasterExpensePolicyId && MasterExpensePolicyId !== '') {
        AccountExpensePolicyId = MasterExpensePolicyId;
     } else if (obj && obj.AccountExpensePolicyId) {
        AccountExpensePolicyId = obj.AccountExpensePolicyId;
     } else if(objectData && objectData.AccountExpensePolicyId){
        AccountExpensePolicyId = objectData.AccountExpensePolicyId;
     }
    const [selectedOptionRuleType, setselectedOptionRuleType] = useState<{ [object: string]: any }>();
    const [selectedOptionLimitType, setselectedOptionLimitType] = useState<{ [object: string]: any }>();
    const [ruleTypeArray, SetExpenseRuleTypeArray] = useState<any | ''>([]);
    const [limitTypeArray, SetExpenseLimitTypeArray] = useState<any | ''>([]);
    const [selectedOption, setSelectedOption] = useState<any | ''>([]);
    const options = [{ label: 'Category', value: true }, { label: 'Expense Type', value: false }];
    const [selectedOptionExpenseType, setselectedOptionExpenseType] = useState<{ [object: string]: any }>();
    const [expenseTypeArray, SetexpenseTypeArray] = useState<any | ''>([]);
    const dispatch = useAppDispatch();
    const {maxMenuHeight} = useAppSelector((state) => state.globalState);
    const [showErrorSummary, setShowErrorSummary] = useState(false);

    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const [isCanvasLoader, setIsCanvasLoader] = useState(true);
    const { t } = useTranslation();

    const getExpenseRuleTypeAsync = async () => {
        const response = await fetchAPI("api/ExpensePolicies/GetDataExenseRuleType", "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        json.map((item: any) => {
            item.value = item.SystemExpenseRuleTypeId;
            item.label = item.SystemExpenseRuleTypeName;
            delete item.SystemExpenseRuleTypeId;
            delete item.SystemExpenseRuleTypeName;
        });
        SetExpenseRuleTypeArray(json);
    }

    const getExpenseLimitTypeAsync = async () => {
        const response = await fetchAPI("api/ExpensePolicies/GetDataExpenseLimitType", "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        json.map((item: any) => {
            item.value = item.SystemExpenseLimitTypeId;
            item.label = item.SystemExpenseLimitTypeName;
            delete item.SystemExpenseLimitTypeId;
            delete item.SystemExpenseLimitTypeName;
        });
        SetExpenseLimitTypeArray(json);
    }

    const getExpenseAndCategoryTypesAsync = async (value: any) => {
        const response = await fetchAPI("api/ExpensePolicies/GetDataForExpenseTypeDropDown/" + value, "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        json.map((item: any) => {
            if (value) {
                item.value = item.AccountExpenseId;
                item.label = item.AccountExpenseName;
                delete item.AccountExpenseId;
                delete item.AccountExpenseName;
            }
            else {
                item.value = item.AccountExpenseTypeId;
                item.label = item.ExpenseType;
                delete item.AccountExpenseTypeId;
                delete item.ExpenseType;
            }
        });
        SetexpenseTypeArray(json);
    }

    useEffect(() => {
        setIsCanvasLoader(true);
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(expensePolicyRuleInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            setCurrentFieldsData(stateItem);
            setselectedOptionRuleType({ value: stateItem.SystemExpenseRuleTypeId, label: stateItem.SystemExpenseRuleTypeName });
            setselectedOptionLimitType({ value: stateItem.SystemExpenseLimitTypeId, label: stateItem.SystemExpenseLimitTypeName });
            if (stateItem.IsExpenseCategoryId) {
                getExpenseAndCategoryTypesAsync(true);
                setSelectedOption({ value: stateItem.IsExpenseCategoryId, label: "Category" });
                setselectedOptionExpenseType({ value: stateItem.AccountExpenseId, label: stateItem.AccountExpenseName});
            } else {
                getExpenseAndCategoryTypesAsync(false);
                setSelectedOption({ value: stateItem.IsExpenseCategoryId, label: "Expense Type" });
                setselectedOptionExpenseType({ value: stateItem.AccountExpenseTypeId, label: stateItem.ExpenseType });
            }
            stateItem.PolicyRuleValue = formatNumberCustomoriginalapiv2(cultureInfoName.toString(), stateItem.PolicyRuleValue, decimalPlaces);
            setIsCanvasLoader(false);
        }
        else {
            setselectedOptionRuleType({ value: 0, label: 'Select' });
            setselectedOptionLimitType({ value: 0, label: 'Select' });
            setSelectedOption({ value: 0, label: 'Select' });
            setselectedOptionExpenseType({ value: 0, label: 'Select' });
            setCurrentFieldsData(expensePolicyRuleInitialsForAdd);
            setIsCanvasLoader(false);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
        if (formikRef.current) {
            formikRef.current.resetForm();
        }
    }, [selectedRecord])

    useEffect(() => {
        getExpenseRuleTypeAsync();
        getExpenseLimitTypeAsync();
        setIsCanvasLoader(false);
    }, [])


       
    const handleOptionChange = (data: any) => {
        const { value, label } = data;
        setSelectedOption({ value: value, label: label });
        getExpenseAndCategoryTypesAsync(value);
    };

   
    const handleSubmit = (values: any) => {
        const updatedValues = {
            ...values,
            IsExpenseCategoryId: selectedOption?.value ,
            PolicyRuleValue: parseLocalizedNumber(values.PolicyRuleValue)
        };
    
        
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateAccountExpensePolicyRulesAsync(updatedValues))
                .unwrap()
                .then((originalPromiseResult) => {
                    ShowToast("Expense Policy Rule Updated Successfully", 'Success', "success", "toast-top-right"); 
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                    console.log('handleSubmit-updateExternalUserAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                })
        }
        else {
            dispatch(addAccountExpensePolicyRuleAsync(updatedValues))
                .unwrap()
                .then((originalPromiseResult) => {
                    ShowToast("Expense Policy Rule Added Successfully", 'Success', "success", "toast-top-right"); 
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }
    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }


   
    return (
        <>
            <Formik
               innerRef={formikRef}
                initialValues={{
                    ...currentFieldsData, AccountExpensePolicyId: AccountExpensePolicyId,
                    SystemExpenseRuleTypeId: selectedOptionRuleType?.value || "", SystemExpenseLimitTypeId: selectedOptionLimitType?.value || ""
                }}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    PolicyRuleName: yup
                        .string()
                        .label('PolicyRuleName')
                        .trim()
                        .required
                        // (t('Rule name is required')),
                        (getValueFromResource('Rule name is required',dispatch, t)),
                    SystemExpenseRuleTypeId: yup
                        .string()
                        .required
                        // (t('Rule type is required')),
                        (getValueFromResource('Rule type is required',dispatch, t)),
                    SystemExpenseLimitTypeId: yup
                        .string()
                        .required
                        // (t('Limit type is required')),
                        (getValueFromResource('Limit type is required',dispatch, t)),
                    // PolicyRuleValue: yup
                    //     .string()
                    //     .label('PolicyRuleValue')
                    //     .trim()
                    //     .required
                    //     // (t('Amount is required')),
                    //     (getValueFromResource('Amount is required',dispatch, t)),
                    PolicyRuleValue: yup
                                            .string()
                                            .label(getValueFromResource('ExpenseAmountLimit', dispatch, t))
                                            .trim()
                                            .required(getValueFromResource('Amount is required', dispatch, t))
                                            .test(
                                                'culture-format-check',
                                                () => {
                                                    const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                    return isComma
                                                        ? "Only numbers and comma (,) are allowed."
                                                        : "Only numbers and dot (.) allowed";
                                                },
                                                (value) => {
                                                    if (!value) return true;
                                                    const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                    if (isComma) {
                                                        return /^\d+(,\d+)?$/.test(value);
                                                    } else {
                                                        return /^\d+(\.\d+)?$/.test(value);
                                                    }
                                                }
                                            ),
                    IsExpenseCategoryId: yup
                        .string()
                        .label('IsExpenseCategoryId')
                        .trim()
                        .required
                        // (t('Category is required'))
                        (getValueFromResource('Category is required',dispatch, t))
                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>

                        <div className='card-body'>
                        {isCanvasLoader ? <CanvasLoader /> : <>
                            {/* {isLoading ?
                                <div className="col-md-12">
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        <span className='spinner-border spinner-border-md ms-2'></span>
                                    </span>
                                </div>
                                : <> */}
                                    <div className='row'>
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Policy Rule Name')} */}
                                                {getValueFromResource('Policy Rule Name',dispatch, t)}
                                                </label>
                                            <input type="text" className="form-control fs-7 fw-normal" id='PolicyRuleName' value={values.PolicyRuleName} name='PolicyRuleName'
                                                onChange={handleChange('PolicyRuleName')}
                                                // onBlur={() => setFieldTouched('PolicyRuleName')}
                                                style={{ color: '#172b4d' }}
                                                ref={defaultFocusRef}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        setFieldTouched('PolicyRuleName', true);
                                                        handleSubmit();
                                                    }
                                                }}
                                            />
                                            <div>
                                                {touched.PolicyRuleName && errors.PolicyRuleName &&
                                                    <p className='errorMsg'>{errors.PolicyRuleName as string}</p>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Rule Type')} */}
                                                {getValueFromResource('Rule Type',dispatch, t)}
                                                </label>                                            
                                            <Select
                                                value={ruleTypeArray.find((option: any) => option.value == values.SystemExpenseRuleTypeId)}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="SystemExpenseRuleTypeId"
                                                onBlur={() => setFieldTouched('SystemExpenseRuleTypeId', true)}
                                                onChange={(selectedOption) => {
                                                    handleChange({
                                                        target: {
                                                            id: "SystemExpenseRuleTypeId",
                                                            value: selectedOption?.value
                                                        },
                                                    });
                                                }}
                                                options={ruleTypeArray}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                            <div style={{ paddingRight: 20 }}>
                                                {touched.SystemExpenseRuleTypeId && errors.SystemExpenseRuleTypeId &&
                                                    <p className='errorMsg'>{errors.SystemExpenseRuleTypeId as string}</p>
                                                }
                                            </div>
                                        </div>
                                        </div>
                                        <div className='row mt-4'>
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Limit Type')} */}
                                                {getValueFromResource('Limit Type',dispatch, t)}
                                                </label>
                                            <Select
                                                value={limitTypeArray.find((option: any) => option.value == values.SystemExpenseLimitTypeId)}
                                                id="SystemExpenseLimitTypeId"
                                                className="basic-single"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="SystemExpenseLimitTypeId"
                                                onBlur={() => setFieldTouched('SystemExpenseLimitTypeId', true)}
                                                onChange={(selectedOption) => {
                                                    handleChange({
                                                        target: {
                                                            id: "SystemExpenseLimitTypeId",
                                                            value: selectedOption?.value
                                                        },
                                                    });
                                                }}
                                                options={limitTypeArray}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                            <div style={{ paddingRight: 20 }}>
                                                {touched.SystemExpenseLimitTypeId && errors.SystemExpenseLimitTypeId &&
                                                    <p className='errorMsg'>{errors.SystemExpenseLimitTypeId as string}</p>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-md-6 ">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Amount')} */}
                                                {getValueFromResource('Amount',dispatch, t)}
                                                </label>
                                            <input type="text" className="form-control fs-7 fw-normal" id='PolicyRuleValue' value={values.PolicyRuleValue} name='PolicyRuleValue'
                                                onChange={handleChange('PolicyRuleValue')}
                                                onBlur={() => setFieldTouched('PolicyRuleValue')}
                                            />
                                            <div style={{ paddingRight: 20 }}>
                                                {touched.PolicyRuleValue && errors.PolicyRuleValue &&
                                                    <p className='errorMsg'>{errors.PolicyRuleValue as string}</p>
                                                }
                                            </div>
                                        </div>
                                        </div>
                                        <div className='row mt-4'>
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Category')} */}
                                                {getValueFromResource('Category',dispatch, t)}
                                                </label>
                                            <Select
                                                // value={options.find((option) => option.value === values.IsExpenseCategoryId)}
                                                value={selectedOption}
                                                id={"IsExpenseCategoryId"}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="expensePolicyRuleList"
                                                onBlur={() => setFieldTouched('expensePolicyRuleList', true)}
                                                onChange={handleOptionChange}
                                                options={options}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                            
                                            <div style={{ paddingRight: 20 }}>
                                                {touched.IsExpenseCategoryId && errors.IsExpenseCategoryId &&
                                                    <p className='errorMsg'>{errors.IsExpenseCategoryId as string}</p>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="fs-7 fw-normal mb-2">
                                                {/* {t('Expense Type')} */}
                                                {getValueFromResource('Expense Type',dispatch, t)}
                                                </label>
                                            <Select
                                                value={expenseTypeArray.find((option: any) => option.value == values.AccountExpenseCategoryOrTypeId)}
                                                id="AccountExpenseCategoryOrTypeId"
                                                className="basic-single"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="AccountExpenseCategoryOrTypeId"
                                                onBlur={() => setFieldTouched('AccountExpenseCategoryOrTypeId', true)}
                                                onChange={(selectedOption) => {
                                                    handleChange({
                                                        target: {
                                                            id: "AccountExpenseCategoryOrTypeId",
                                                            value: selectedOption?.value
                                                        },
                                                    });
                                                }}
                                                options={expenseTypeArray}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}

                                            />
                                            <div style={{ paddingRight: 20 }}>
                                                {touched.AccountExpenseCategoryOrTypeId && errors.AccountExpenseCategoryOrTypeId &&
                                                    <p className='errorMsg'>{errors.AccountExpenseCategoryOrTypeId as string}</p>
                                                }
                                            </div>
                                        </div>
                                        {Object.keys(selectedRecord).length > 0 ? (
                                            <div className="mb-3" >
                                                <label className="fs-7 fw-normal mb-2 mt-2">
                                                    {/* {t('Disabled')} */}
                                                    {getValueFromResource('Disabled',dispatch, t)}
                                                    </label>
                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                    <input className="form-check-input h-20px w-30px mt-1" type="checkbox" checked={values.IsDisabled} id="IsDisabled" name="IsDisabled"
                                                        onChange={handleChange('IsDisabled')}
                                                    />
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                {/* </>
                            } */}
                             </>
                             }
                              {showErrorSummary && Object.keys(errors).length > 0 && (
                        <div className="mt-3 alert alert-danger">
                            <strong>
                                {/* {t('Error Summary')}: */}
                                {getValueFromResource('Error Summary',dispatch, t)}:
                                </strong>
                            <ul>
                                {Object.keys(errors).map((fieldName, index) => (
                                    <li key={index}>{errors[fieldName] as string}</li>
                                ))}
                        </ul>
                    </div>
                )}
                        </div>

                        <div className='card-footer pt-4'>
                            <div className='d-flex flex-stack float-end'>
                              
                                <button
                                    ref={closeButtonRef}
                                    type="button"
                                    className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                                    id="kt_OffCanvas"
                                    onClick={handleCloseOnClickEvent}
                                >
                                    {/* {t('Cancel')} */}
                                    {getValueFromResource('Cancel',dispatch, t)}
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    onClick={() => { setShowErrorSummary(true); 
                                        handleSubmit();
                                    }}
                                    //onClick={() => handleSubmit()}
                                    data-kt-element='send'
                                >
                                     {/* {t('Save')}   */}
                                     {getValueFromResource('Save',dispatch, t)}
                                </button>
                                {/* </div> */}
                            </div>
                        </div>
                    </Fragment>
                )}
            </Formik>
        </>

    )
    
}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
export default ExpensePolicyRuleForm